import moment from "moment";
import React, { Component } from "react";
import "./ActionButtons.scss";
import imgCancelApplication from "../../../images/cancel-application.png";
import imgChangeOwnership from "../../../images/change-ownership.png";
import imgReRunApplication from "../../../images/rerun-application.png";
import imgCopyApplication from "../../../images/copy-application.png";
import ReactTooltip from "react-tooltip";

class ActionButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showButtons: false,
        };
    }

    handleAssignBank() {
        if (this.props.onAssignBank) {
            this.props.onAssignBank(this.props.preapp);
        }
    }

    handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel(this.props.preapp);
        }
    }

    handleChangeOwnership() {
        if (this.props.onChangeOwnership) {
            this.props.onChangeOwnership();
        }
    }

    handleReRun() {
        if (this.props.onReRun) {
            this.props.onReRun(this.props.preapp);
        }
    }

    handleCopy() {
        if (this.props.onCopy) {
            this.props.onCopy(this.props.preapp);
        }
    }

    render() {
        const { showButtons, preapp, pci_admin } = this.props;

        const showAssignBank =
            (this.props.showAssignBank && pci_admin) || false;
        const showMerchantColumn = this.props.showMerchantColumn || false;

        return (
            <div
                className={
                    this.props.user.role !== "agent"
                        ? "action-buttons"
                        : "action-buttons action-btn-agent"
                }
            >
                {showButtons ? (
                    <div
                        className={
                            showAssignBank
                                ? "buttons"
                                : "buttons hide-assign-btn"
                        }
                    >
                        <div className="hoveractionbutton">
                            <a
                                className="btn btn-light btn-xs "
                                onClick={() => this.handleCancel()}
                                title="Cancel Application"
                            >
                                <img
                                    src={imgCancelApplication}
                                    style={{ width: "12px", height: "12px" }}
                                />
                            </a>
                            {pci_admin ? (
                                <a
                                    className="btn btn-light btn-xs "
                                    onClick={() => this.handleChangeOwnership()}
                                    title="Change ownership"
                                    data-for="ownership"
                                >
                                    <img
                                        src={imgChangeOwnership}
                                        style={{
                                            width: "25px",
                                            height: "25px",
                                        }}
                                    />
                                </a>
                            ) : (
                                <div></div>
                            )}
                            {pci_admin ? (
                                <a
                                    className="btn btn-light btn-xs "
                                    onClick={() => this.handleReRun()}
                                    title="Re-run application"
                                    data-for="re-run"
                                >
                                    <img
                                        src={imgReRunApplication}
                                        style={{
                                            width: "12px",
                                            height: "12px",
                                        }}
                                    />
                                </a>
                            ) : (
                                <div></div>
                            )}
                            <a
                                className="btn btn-light btn-xs "
                                onClick={() => this.handleCopy()}
                                title="Copy application"
                                data-for="copy"
                            >
                                <img
                                    src={imgCopyApplication}
                                    style={{ width: "25px", height: "25px" }}
                                />
                            </a>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="col-created-at">
                            {preapp.approved_at != null ? (
                                moment(preapp.approved_at).format("MMM D, YYYY")
                            ) : (
                                <>&mdash;</>
                            )}
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default ActionButtons;
